import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AppInfoService, EmbededModeService } from '../../shared/services';
import { SideNavOuterToolbarComponent } from '../../layouts/side-nav-outer-toolbar/side-nav-outer-toolbar.component';
import { EmbededToolbarComponent } from '../../layouts/embeded-toolbar/embeded-toolbar.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-secure-page',
    templateUrl: './secure-page.component.html',
    styleUrls: ['./secure-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SideNavOuterToolbarComponent,
        EmbededToolbarComponent,
        RouterOutlet,
    ],
})
export class SecurePageComponent {
    appInfo = inject(AppInfoService);
    // Fixed for the life of the document, so the layout never swaps under
    // a live page.
    embededMode = inject(EmbededModeService);
}
